import React, { useContext } from 'react';
import i18next from "i18next";
import { MenuItem } from "@mui/material";
import useStyles from "style/js-style/containers/users/users-list/UsersDataTableStyle";
import EAIcon from "components/common/EAIcon";
import { PrivilegeEnum, RoleBasedAccessControlContext } from '../../../../services/common/RolesUtils';

export const DossierModelActionMenu = ({
  dossierModelSelected,
  onOpenDeleteDialog,
  onChangeNature,
  onChangeActive
}) => {
  const { classes } = useStyles();
  const [actionMenuIsOpen, setActionMenuIsOpen] = React.useState(false);
  const { hasAnyOfPrivileges } = useContext(RoleBasedAccessControlContext);

  const handleClick = () => {
    setActionMenuIsOpen(!actionMenuIsOpen);
  };

  return (
    <div
      className={
        dossierModelSelected.length < 1
          ? classes.dnone
          : classes.actionMenuWrapper
      }
      onMouseEnter={handleClick}
      onMouseLeave={handleClick}
    >
      <div className={classes.actionMenuTitle}>
        {i18next.t('actions')}
        <EAIcon
          icon={
            !actionMenuIsOpen
              ? 'arrow/arrow-to-down_small'
              : 'arrow/arrow-to-up_small'
          }
          className={classes.titleArrow}
        />
      </div>

      <div className={actionMenuIsOpen ? '' : classes.dnone}>
        <div className={classes.actionMenuSeparate} />
        <MenuItem
          className={classes.actionMenuItem}
          disabled={
            !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_EDIT_DOSSIER_TYPE)
          }
          onClick={() => onChangeActive(dossierModelSelected, true)}
        >
          {i18next.t('demandes.dossierModel.tableAction.activate')}
        </MenuItem>
        <MenuItem
          className={classes.actionMenuItem}
          disabled={
            !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_EDIT_DOSSIER_TYPE)
          }
          onClick={() => onChangeActive(dossierModelSelected, false)}
        >
          {i18next.t('demandes.dossierModel.tableAction.deactivate')}
        </MenuItem>
        <MenuItem
          className={classes.actionMenuItem}
          disabled={
            !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_EDIT_DOSSIER_TYPE)
          }
          onClick={() => onChangeNature(dossierModelSelected, true)}
        >
          {i18next.t('demandes.dossierModel.tableAction.lock')}
        </MenuItem>
        <MenuItem
          className={classes.actionMenuItem}
          disabled={
            !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_EDIT_DOSSIER_TYPE)
          }
          onClick={() => onChangeNature(dossierModelSelected, false)}
        >
          {i18next.t('demandes.dossierModel.tableAction.unlock')}
        </MenuItem>
        {/* /!\ we can't delete a model if it is used by a dosser */}
        <MenuItem
          className={classes.actionMenuItem}
          disabled={
            !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_EDIT_DOSSIER_TYPE)
          }
          onClick={() => onOpenDeleteDialog(dossierModelSelected)}
        >
          {i18next.t('demandes.dossierModel.tableAction.delete')}
        </MenuItem>
      </div>
    </div>
  );
};
